import { useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";
import { useCart } from "../../contexts/CartContext";

const LeftMenu = ({ onChange, onLogout }) => {
  const navigate = useNavigate();
  const location = useLocation(); // Get current URL path
  const { signOut } = useAuth();
  const { fetchCart } = useCart();
  const menuItems = [
    { label: "Dashboard", url: "/account" },
    { label: "Meal subscriptions", url: "/account/subscriptions" },
    { label: "Orders", url: "/account/orders" },
    { label: "Profile management", url: "/account/profile" },
    { label: "Payments", url: "/account/payments" },
    //{ label: "Child management", url: "/account/child" },
    { label: "Cart", url: "/account/cart" },
    { label: "Logout" }, // No URL for logout
  ];

  return (
    <div className="grid grid-cols-1 gap-3">
      {menuItems.map((item) => {
        let isActive = false;

        if (item.url) {
          if (item.url === "/account") {
            isActive = location.pathname === item.url;
          } else {
            isActive = location.pathname.startsWith(item.url);
          }
        }

        return (
          <div
            key={item.label}
            onClick={async () => {
              onChange(item.label);
              if (item.label === "Logout") {
                onLogout();
              } else if (item.url) {
                navigate(item.url);
              }
            }}
            className={`w-full min-h-[50px] 1xl:h-[77px] 2.5xl:h-[97px] rounded-[26px] flex items-center justify-center cursor-pointer transition-all duration-300
              ${
                isActive
                  ? "bg-quaternary/60"
                  : "bg-quaternary/20 hover:bg-quaternary/30"
              }`}
          >
            <p
              className={`${
                isActive
                  ? "text-18pt 1xl:text-20pt 2.5xl:text-30pt text-secondary"
                  : "text-18pt 1xl:text-20pt 2.5xl:text-26pt text-quaternary"
              } transition-all duration-300 text-center`}
            >
              {item.label}
            </p>
          </div>
        );
      })}
    </div>
  );
};

export default LeftMenu;
